import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import './../fields.css';

class TextField extends React.Component {
    render() {
        const {
            input,
            placeholder,
            type,
            disabled,
            autoComplete,
            autoCorrect,
            hideErrors,
            intl,
            extras,
            id,
            meta: { touched, error, warning }
        } = this.props;
        let placeholderContent = typeof placeholder === 'string' ? placeholder : intl.formatMessage(placeholder);

        if (disabled) {
            return (
                <div className="text-field">
                    <div className="field-placeholder">{placeholderContent}</div>
                    <span id={id ? id : ''} className="disabled-input">
                        {input.value}
                    </span>
                    <span className="validation-message" />
                </div>
            );
        }

        if (extras) {
            const { left, right } = extras;
            return (
                <div className={`text-field ${left ? 'with-left-extra' : ''} ${right ? 'with-right-extra' : ''}`}>
                    {(input.value || input.value === 0) && <div className="field-placeholder">{placeholderContent}</div>}
                    {left && <div className="text-left-extra no-select">{left}</div>}
                    {right && <div className="text-right-extra no-select">{right}</div>}
                    <input
                        placeholder={placeholderContent}
                        type={type ? type : 'text'}
                        disabled={disabled}
                        autoComplete={autoComplete ? autoComplete : 'off'}
                        autoCorrect={autoCorrect ? autoCorrect : 'off'}
                        {...input}
                    />
                    {hideErrors === undefined && <span className="validation-message">{touched && (error || warning)}</span>}
                </div>
            );
        }
        return (
            <div className="text-field">
                {(input.value || input.value === 0) && <div className="field-placeholder">{placeholderContent}</div>}
                <input
                    placeholder={placeholderContent}
                    type={type ? type : 'text'}
                    {...(id ? { id } : {})}
                    disabled={disabled}
                    autoComplete={autoComplete ? autoComplete : 'off'}
                    autoCorrect={autoCorrect ? autoCorrect : 'off'}
                    {...input}
                />
                <span className="validation-message">{touched && !hideErrors && (error || warning)}</span>
            </div>
        );
    }
}

TextField.defaultProps = {
    placeholder: '',
    type: '',
    meta: {},
    input: {}
};

TextField.propTypes = {
    placeholder: PropTypes.any,
    type: PropTypes.string,
    meta: PropTypes.object,
    input: PropTypes.object
};

export default injectIntl(TextField);



// WEBPACK FOOTER //
// ./src/components/fields/text/index.jsx